<template>
    <div>
        <Topheader></Topheader>
        <div class="w1100 list-body">

            <div class="top-title-body">
                <div class="back-btn" @click="$router.go(-1)">返回竞技比赛预测</div>
                <div class="top-spk">请正确公正点选预测结果，点选只有一次。</div>
            </div>

            <div class="tab-top">
                <div class="tab-left">预测目录</div>
                <div style="display: flex;align-items: center">
                    <div class="tab-right" style="margin-right: 181px;">赛事比分</div>
                    <div class="tab-right">预测结果</div>
                </div>

            </div>

            <div class="list-content">
                <div class="list-info" v-for="(vo,key) in list">
                    <div class="lest-left">

                        <div class="dw-body">
                            <div class="dw-left">
                                <div class="dw-name">{{vo.athletics.troops1_name}}</div>
                                <el-image class="dw-logo" fit="scale-down" :src="vo.athletics.troops1_img_url"></el-image>
                            </div>
                            <div>
                                <div class="time">{{vo.athletics.bs_time}}</div>
                                <div class="type-t">{{vo.athletics.title}}</div>
                            </div>
                            <div class="dw-right">
                                <el-image class="dw-logo" fit="scale-down" :src="vo.athletics.troops2_img_url"></el-image>
                                <div class="dw-name">{{vo.athletics.troops2_name}}</div>
                            </div>
                        </div>
                    </div>

                    <div v-if="vo.athletics.jieguo" class="fenshu-body">
                        <div class="score">{{vo.athletics.troops1_score}}</div>
                        <div>:</div>
                        <div class="score">{{vo.athletics.troops1_score}}</div>
                    </div>
                    <div v-else class="fenshu-body">
                        <input type="text" v-model="vo.troops1_score" placeholder="分数">
                        <div>:</div>
                        <input type="text" v-model="vo.troops2_score" placeholder="分数">
                    </div>

                    <div v-if="vo.athletics.jieguo == 1" class="list-right">
                        <div class="btn-body btn-ying2">胜</div>
                        <div class="btn-body btn-ds">输</div>
                        <div class="btn-body btn-ds">走</div>
                        <div class="over_btn">完成</div>
                    </div>
                    <div v-else-if="vo.athletics.jieguo == 2" class="list-right">
                        <div class="btn-body btn-ds">胜</div>
                        <div class="btn-body btn-shu2">输</div>
                        <div class="btn-body btn-ds">走</div>
                        <div class="over_btn">完成</div>
                    </div>
                    <div v-else-if="vo.athletics.jieguo == 3" class="list-right">
                        <div class="btn-body btn-ds">胜</div>
                        <div class="btn-body btn-ds">输</div>
                        <div class="btn-body btn-zou2">走</div>

                        <div class="over_btn">完成</div>
                    </div>
                    <div v-else class="list-right">
                        <div class="btn-body" :class="vo.jieguo == 1 ? 'btn-ying' :'btn-ds'" @click="clickJieguo(key,1)">胜</div>
                        <div class="btn-body" :class="vo.jieguo == 2 ? 'btn-shu' :'btn-ds'"  @click="clickJieguo(key,2)">输</div>
                        <div class="btn-body" :class="vo.jieguo == 3 ? 'btn-zou' :'btn-ds'"  @click="clickJieguo(key,3)">走</div>
                        <div class="suer_btn" @click="onHandel(key)">确定</div>
                    </div>
                </div>

                <!--加载更多-->
                <div
                        style="margin-top: 40px;"
                        class="loading"
                        v-loading="loading"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(246, 246, 246, 0.8)"
                ></div>

            </div>


        <div>{{str}}</div>
        </div>

    </div>
</template>

<script>
    import Topheader from "../components/header"; //上传图片

    export default {
        components: {
            Topheader
        },
        name: "cpnList",
        data() {
            return {
                list:[],
                page:1,
                page_num:15,
                loading: false,
                loadingType: 0, //0=可以加载 1=加载中 2=已加载完毕
                str:'',
            };
        },
        created() {
            this.getList();
            window.addEventListener("scroll", this.onScroll);
        },
        //方法定义
        methods: {
            clickJieguo(key,type){
                let _this=this;
                if(_this.list[key]['jieguo'] == type){
                    _this.list[key]['jieguo']=null;
                }else {
                    _this.list[key]['jieguo']=type;
                }

                _this.str+= ' ';
            },
            onHandel(key){
              let _this=this;
                let info=_this.list[key];
                let data={
                    id:info.id
                };

                if(info.jieguo){
                    data.type=info.jieguo;
                }

                if(info.troops1_score){
                    data.troops1_score=info.troops1_score;
                }

                if(info.troops2_score){
                    data.troops2_score=info.troops2_score;
                }

                _this.common.request('api/athletics/handel',data,function (res) {
                    if(res.status == 200){
                        _this.common.vMessage(res.message);
                        _this.list[key]['athletics'].jieguo=data['type'];
                        _this.list[key]['athletics'].troops1_score=data['troops1_score'];
                        _this.list[key]['athletics'].troops2_score=data['troops2_score'];
                        _this.str+= ' ';
                        console.log(_this.list[key]);
                    }
                },'post')
            },
            getList(){
                let _this=this;
                let data={
                    page:_this.page,
                    page_num: _this.page_num
                };
                _this.common.request('api/dynamic/myJjList',data,function (res) {
                    if(res.status == 200){
                        _this.list=res.data.list;
                    }
                })
            },
            //加载跟多
            onScroll() {
                //可滚动容器的高度
                let innerHeight = document.querySelector("#app").clientHeight;
                //屏幕尺寸高度
                let outerHeight = document.documentElement.clientHeight;
                //可滚动容器超出当前窗口显示范围的高度
                let scrollTop = document.documentElement.scrollTop;
                //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
                if (innerHeight <= outerHeight + scrollTop) {
                    let _this = this;
                    if (_this.loadingType != 0) {
                        return;
                    }
                    _this.loadingType = 1;
                    _this.loading = true;
                    _this.page++;
                    let list = [];
                    let data = {
                        page: _this.page,
                        page_num: _this.page_num
                    };
                    _this.common.request("api/dynamic/myJjList", data, function(res) {
                        if (res.status == 200) {
                            list = res.data.list; //请求数据
                            _this.loading = false;
                            if (list.length <= 0) {
                                _this.loadingType = 2;
                                return;
                            }
                            _this.list = _this.list.concat(list);
                            _this.loadingType = 0;
                        }
                    });
                }
            },
        }
    }
</script>

<style scoped lang='less' rel="stylesheet/less">

.list-body{
    background-color: #FFF;
    min-height:700px;
    background:rgba(255,255,255,1);
    margin-top: 20px;
}
    .top-title-body{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 60px;
    }
    .back-btn{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(34,138,227,1);
        cursor: pointer;
    }
    .top-spk{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(155,155,155,1);
        margin-left: 10px;
    }
    .tab-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ECECEC;
        height: 40px;
    }
    .tab-left,.tab-right{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
    }
    .tab-left{
        margin-left: 30px;
    }
    .tab-right{
        margin-right: 120px;
    }

    .list-info{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1040px;
        margin: 0 auto;
        padding: 10px 0;
        border-bottom: 1px solid #E7E7E7;
    }
    .time,.type-t{
        text-align: center;
    }
    .time{
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(72,72,72,1);
    }
    .type-t{
        font-size:16px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(72,72,72,1);
    }
    .list-right{
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
        width: 450px;
    }
    .dw-body{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 580px;
    }
    .dw-left,.dw-right{
        display: flex;
        align-items: center;
        justify-content: space-between;
/*
        width: 300px;
*/
    }
    .dw-center{
        text-align: center;
    }
    .dw-logo{
        height: 38px;
        width: 100px;
    }
    .dw-name{
        font-size:18px;
        font-family:PingFang SC;
        font-weight:bold;
        color:rgba(72,72,72,1);
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        width: 140px;
    }
    .dw-sc{
        font-size:24px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(72,72,72,1);
    }
    .dw-center{
        font-size:24px;
        font-family:PingFang SC;
        font-weight:800;
        color:rgba(72,72,72,1);
    }
    .btn-body{
        width:66px;
        height:48px;
        border-radius:12px;
        text-align: center;
        line-height: 48px;
        font-size:24px;
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:rgba(255,255,255,1);
        cursor: pointer;
    }
    .btn-ds{
        background:rgba(241,241,241,1);
    }
    .btn-ying{
        background:rgba(56,218,24,1);
    }
.btn-ying:hover{
    background:rgba(56,218,24,0.8);
}
    .btn-shu{
        background:rgba(239,27,127,1);
    }
.btn-zou{
    background:rgba(107,101,104,1);
}
.btn-shu:hover{
    background:rgba(239,27,127,0.8);
}
    .btn-shu2{
        background:rgba(182,27,100,1);
    }
    .btn-ying2{
        background:rgba(41,149,19,1);
    }
.btn-zou2{
    background:rgba(15,14,14,1);
}

    .fenshu-body{
        width: 200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: center;
    }
.fenshu-body div{
    font-weight: bold;
}
.fenshu-body input,.fenshu-body div{
    text-align: center;
    width: 45px;
}
    .suer_btn{
        width: 60px;
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(30,112,205,1);
        height:48px;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
    }
    .over_btn{
        width: 60px;
        font-size:18px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(114,124,136,1);
        height:48px;
        line-height: 48px;
        text-align: center;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/view/cpnList.vue